import { http } from '../util/http'
import { API_KOTLIN_DOMAIN, API_DOMAIN } from '../config'
import headers from './employeeSystemHeader'

// 桌台列表
export const fetchTableList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/table`,
    params,
  })
}

// 价格修改记录列表
export const fetchChangeList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/table/operateLog`,
    params,
  })
}

// 批量重置低消
export const postTablesLowPrice = (data) => {
  return http({
    headers: headers(),
    url: `${API_DOMAIN}/ServiceApi/clearMinCons`,
    method: 'post',
    data,
  })
}

// 批量重置分时段设置
export const postTablesTimePrice = (data) => {
  return http({
    headers: headers(),
    url: `${API_DOMAIN}/ServiceApi/clearMinIns`,
    method: 'post',
    data,
  })
}

// 获取已删除球台
export const fetchDeletedTable = (params) => {
  return http({
    headers: headers(),
    url: `${API_DOMAIN}/Home/BossApi/getDisabledTable`,
    params,
  })
}

// 启用已删除球台
export const postEnabledTable = (data) => {
  return http({
    headers: headers(),
    url: `${API_DOMAIN}Home/BossApi/enableTable`,
    method: 'post',
    data,
  })
}

// 获取充送可用球台列表
export const fetchChargeTableList = (params) => {
  return http({
    headers: headers(),
    url: `${API_DOMAIN}/Home/BossApi/getCouponTable`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/clubTable.js